import * as yup from 'yup';

export const loginSchema = yup.object({
    email_id: yup.string().email().required(),
    password: yup.string().required(),
})